import React, { useState } from "react";
import { Form, Input, Drawer, Button, Divider, Select, message, Space } from "antd";
import { ContractAutocomplete } from "src/shared";
import { CopyOutlined, PlusOutlined } from "@ant-design/icons";

const DocSalesDrawer = (props) => {
  const api = `https://${process.env.REACT_APP_APP_URL}/api/v1/`;
  const [visible, setVisible] = useState(false);
  const [tagInput, setTagInput] = useState("");
  const [tagType, setTagType] = useState("deal"); // deal | customer

  const handleCopyTag = (tag) => {
    navigator.clipboard.writeText(tag);
    message.success(`Тег "${tag}" скопирован`);
  };

  const tagRender = (props) => {
    const { label, closable, onClose } = props;
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          background: "#f3f3f3",
          border: "1px solid #d9d9d9",
          borderRadius: 4,
          padding: "0 6px",
          marginRight: 4,
          marginBottom: 2,
        }}
      >
        <span style={{ marginRight: 4 }}>{label}</span>
        <CopyOutlined
          style={{ cursor: "pointer", color: "#1890ff", marginRight: 4 }}
          onClick={() => handleCopyTag(label)}
        />
        {closable && (
          <span
            style={{ cursor: "pointer", color: "#ff4d4f" }}
            onClick={onClose}
          >
            ×
          </span>
        )}
      </span>
    );
  };

  const typeOptions = [
    { value: "deal", label: "Сделка" },
    { value: "customer", label: "Покупатель" },
  ];

  return (
    <div>
      <Button
        onClick={() => setVisible(true)}
        style={{ width: "100%", marginBottom: 12 }}
      >
        Доп. параметры
      </Button>
      <Drawer
        title="Дополнительные параметры"
        placement="right"
        onClose={() => setVisible(false)}
        open={visible}
        width={500}
      >
        <Form.Item label="Номер" name="number">
          <Input />
        </Form.Item>
        <Form.Item label="Комментарий" name="comment">
          <Input />
        </Form.Item>
        <Form.Item label="Договор" name="contract">
          <ContractAutocomplete
            onSelect={props.onSelectContract}
            api={api}
            token={props.token}
          />
        </Form.Item>
        <Divider />
       
        <Form.Item name="tags" label="Теги">
          <Select
            mode="tags"
            allowClear
            style={{ minWidth: 200, flex: 1 }}
            placeholder="Введите или выберите теги"
            tagRender={tagRender}
          />
        </Form.Item>
        <Form.Item>
          <Space.Compact block>
            <Input
              placeholder="Введите ID"
              value={tagInput}
              onChange={e => setTagInput(e.target.value)}
              onPressEnter={() => {
                if (!tagInput) return;
                const form = props.form;
                const currentTags = form?.getFieldValue?.("tags") || [];
                const newTag = tagType === "customer"
                  ? `CUSTOMERS_ID_${tagInput}`
                  : `ID_${tagInput}`;
                if (!currentTags.includes(newTag)) {
                  form?.setFieldsValue?.({ tags: [...currentTags, newTag] });
                  setTagInput("");
                } else {
                  message.info("Такой тег уже добавлен");
                }
              }}
              addonBefore={
                <Select
                  value={tagType}
                  onChange={setTagType}
                  options={typeOptions}
                  style={{ width: 100 }}
                  size="small"
                  bordered={false}
                  dropdownStyle={{ minWidth: 120 }}
                />
              }
            />
            <Button
              onClick={() => {
                if (!tagInput) return;
                const form = props.form;
                const currentTags = form?.getFieldValue?.("tags") || [];
                const newTag = tagType === "customer"
                  ? `CUSTOMERS_ID_${tagInput}`
                  : `ID_${tagInput}`;
                if (!currentTags.includes(newTag)) {
                  form?.setFieldsValue?.({ tags: [...currentTags, newTag] });
                  setTagInput("");
                } else {
                  message.info("Такой тег уже добавлен");
                }
              }}
              type="primary"
              icon={<PlusOutlined />}
            />
          </Space.Compact>
        </Form.Item>
      </Drawer>
    </div>
  );
};

export default DocSalesDrawer;
